import React, { useMemo, useRef, useState } from "react";
import LoadingSpinner from "../../helper-components/loading-spinner";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import StockAuditHeaderSection from "./stock-audit-header-section";
import AuditItemsSection from "./audit-items-section";
import AuditFooterSection from "./audit-footer-section";
import moment from "moment";
import { useDispatch } from "react-redux";
import {
  stockAuditCreateAction,
  stockAuditEditAction,
} from "../../../redux/actions/stock-details-audit-action";
import successToast from "../../helper-components/success-toast";
import errorToast from "../../helper-components/error-toast";
import { useNavigate } from "react-router-dom";

const CreateEditViewStockAudit = ({
  audit = {},
  loading,
  setLoading,
  disabled = false,
  page = "create",
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const corr_ref = useRef();
  const searchRef = useRef();
  const [submitLoading, setSubmitLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState({
    itemid: "",
    item_name: "",
    index: null,
    item_batch_number: "",
  });
  const [batchModalOpen, setBatchModalOpen] = useState(false);
  const initialValues = {
    sat_id: audit?.sat_id || "",
    date:
      moment(audit.date).format("YYYY-MM-DD") ||
      moment(new Date()).format("YYYY-MM-DD"),
    audit_type: audit?.audit_type || "",
    comments: audit?.comments || "",
    total_items_count: audit?.total_items_count || 0,
    total_matched_item: audit?.total_matched_item || 0,
    total_miss_matched_item: audit?.total_miss_matched_item || 0,
    total_added_item_value: audit?.total_added_item_value || 0,
    total_removed_item_value: audit?.total_removed_item_value || 0,
    total_item_net_difference: audit?.total_item_net_difference || 0,
    available_quantity: audit?.available_quantity || 0,
    mrp_price: audit?.mrp_price || 0,
    is_stock_draft: audit?.is_stock_draft || false,
    created_by: audit?.created_by || "",
    tempRowData: {
      item_code: "",
      item_name: "",
      item_batch_number: "",
      item_uom: "",
      item_batch_purchase_rate: "",
      item_quantity: "",
      item_correction_quantity: "",
      updated_quantity: "",
      item_id: "",
      item_generic_name: "",
      item_uom_id: "",
      item_exp_date: "",
      item_mfg_date: "",
      correction: "-",
      item_total_amount: 0,
      item_current_amount: 0,
      item_adjusted_amount: "",
      item_current_adjusted_diff: "",
      to_bin_id: "",
      item_rack_location: "",
      is_stock_draft: false,
      created_by: "",
    },
    stockAuditRecordData:
      audit?.items?.map((item, index) => ({
        sot_id: audit?.sot_id || "",
        sait_id: item?.sait_id || "",
        sl_no: index + 1,
        item_code: item?.item_code || "",
        item_name: item?.item_name || "",
        item_batch_number: item?.item_batch_number || "",
        item_uom: item?.item_uom || "",
        item_batch_purchase_rate: item?.item_batch_purchase_rate || "",
        item_quantity: item?.item_quantity || "",
        item_correction_quantity: item?.item_correction_quantity || "",
        updated_quantity: item?.updated_quantity || "",
        item_id: item?.item_id || "",
        item_generic_name: item?.item_generic_name || "",
        item_uom_id: item?.item_uom_id || "",
        item_exp_date: moment(item?.item_exp_date).format("YYYY-MM-DD") || "",
        item_mfg_date: item?.item_mfg_date || "",
        item_total_amount: item?.item_total_amount || 0,
        correction: item?.correction || "-",
        item_current_amount: item?.item_current_amount || 0,
        item_adjusted_amount: item?.item_adjusted_amount || "",
        item_current_adjusted_diff: item?.item_current_adjusted_diff || "",
        to_bin_id: item?.to_bin_id || "",
        item_rack_location: item?.item_rack_location || "",
      })) || [],
    filters: {
      
      items: [],
    },
  };

  const validationSchema = Yup.object().shape({
    date: Yup.string().required("Date is required"),
    audit_type: Yup.string().required("Audit type is required"),
  });
  const onSubmit = (values) => {
    let actionType = stockAuditCreateAction;
    if (page === "edit") {
      actionType = stockAuditEditAction;
    }
    setSubmitLoading(true);
    const payload = {
      stockAuditData: {
        ...(values?.sat_id ? { sat_id: values?.sat_id } : {}),
        date: moment(values.date).format("YYYY-MM-DD HH:mm:ss.SSS Z"),
        audit_type: values.audit_type,
        comments: values.comments,
        item_quantity: values.stockAuditRecordData.reduce(
          (sum, item) => sum + Number(item.item_quantity || 0),
          0
        ),
        total_items_count: values.total_items_count,
        total_matched_item: values.total_matched_item,
        total_miss_matched_item: values.total_miss_matched_item,
        total_added_item_value: values.total_added_item_value,
        total_removed_item_value: values.total_removed_item_value,
        total_item_net_difference: values.total_item_net_difference,
        available_quantity: values.available_quantity,
        mrp_price: values.mrp_price,
        is_stock_draft: values?.submittedButton === "draft" ? true : false,
        created_by: values.created_by,
      },
      stockAuditRecordData: values.stockAuditRecordData.map((item) => ({
        ...(values?.sat_id ? { sat_id: values?.sat_id } : {}),
        ...(item?.sait_id ? { sait_id: item?.sait_id } : {}),
        item_id: item.item_id,
        item_code: item.item_code,
        item_generic_name: item.item_generic_name,
        item_name: item.item_name,
        item_pack_size: item.item_pack_size,
        item_uom: item.item_uom,
        item_uom_id: item.item_uom_id,
        item_batch_number: item.item_batch_number,
        item_quantity: Number(item.item_quantity || 0),
        item_exp_date: item.item_exp_date,
        item_mfg_date: item.item_mfg_date || null,
        item_batch_purchase_rate: item?.item_batch_purchase_rate || 0,
        item_correction_quantity: item.item_correction_quantity,
        item_total_amount: Number(item.item_total_amount || 0),
        updated_quantity: item.updated_quantity,
        correction: item.correction || "-",
        item_current_amount: Number(item.item_current_amount || 0),
        item_adjusted_amount: item.item_adjusted_amount,
        item_current_adjusted_diff: item.item_current_adjusted_diff,
        to_bin_id: item.to_bin_id,
        item_rack_location: item.item_rack_location,
        is_stock_draft: values?.submittedButton === "draft" ? true : false,
      })),
    };

    dispatch(actionType(payload, onSuccessAudit, onErrorAudit));
  };

  const onSuccessAudit = (data) => {
    setSubmitLoading(false);
    successToast(data?.message);
    navigate("/stock-audit");
  };
  const onErrorAudit = (data) => {
    errorToast(data?.data?.message);
    setSubmitLoading(false);
  };
  return (
    <div className="h-full">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ values, handleSubmit }) => {
            return (
              <Form
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                  }
                }}
                className="h-full w-full"
              >
                <div
                  style={{
                    height: `calc(100% - 13rem)`,
                  }}
                  className="mx-5 flex flex-col h-full "
                >
                  <StockAuditHeaderSection
                    page={page}
                    disabled={disabled}
                    initialValues={initialValues}
                    setSelectedItem={setSelectedItem}
                    selectedItem={selectedItem}
                  />
                  <AuditItemsSection
                    disabled={disabled}
                    setSelectedItem={setSelectedItem}
                    selectedItem={selectedItem}
                    initialValues={initialValues}
                    searchRef={searchRef}
                    corr_ref={corr_ref}
                    setLoading={setLoading}
                    setBatchModalOpen={setBatchModalOpen}
                    batchModalOpen={batchModalOpen}
                  />
                </div>
                <div className="h-[13rem]">
                  <AuditFooterSection
                    submitLoading={submitLoading}
                    disabled={disabled}
                  />
                </div>
              </Form>
            );
          }}
        </Formik>
      )}
    </div>
  );
};

export default CreateEditViewStockAudit;
